import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const ContainerTitulo = styled.div`
margin-bottom: 50px;
animation: fadein 300ms; 
@keyframes fadein {
 0% {
 opacity:0;
 }
 50%{
 opacity:0.5;
 }
 100% {
 opacity:1;
 }
}
`;

export const ContainerInput = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  width: 20%;
  height: 50%;
  border: 3px solid #89dddb;
  border-radius: 50px;
  padding: 30px;
  padding-top: 60px;
  padding-bottom: 60px;
  box-shadow: 0px 0px 60px #51c0dc;
  background-color: black;
  animation: fadein 500ms; 
@keyframes fadein {
 0% {
 opacity:0;
 }
 50%{
 opacity:0.5;
 }
 100% {
 opacity:1;
 }
}
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 80%;
`;

export const Input = styled.input`
margin-bottom: 10px;
width: 100%;
border-radius: 30px;

&:focus{
  outline: none;
  border: 4px solid #89dddb;
}
`;

export const Label = styled.label`
  color: #89dddb;
  margin-bottom: 10px;
  margin-top: 20px;
  font-weight: bold;
  font-size: 20px;
`;

export const Text = styled.textarea`
width: 100%;
border-radius: 20px;
padding: 5px;
&:focus{
  outline: none;
  border: 4px solid #89dddb;
}
`;

export const Button = styled.button`
  font-family: 'Disco';
  font-weight: bold;
  letter-spacing: 2px;
  font-size: 20px;
  width: 150px;
  border: 3px solid #89dddb;
  border-radius: 30px;
  color: #89dddb;
  background-color: black;
  margin-top: 20px;
  margin-bottom: 20px;
  &:hover {
    transition: 700ms;
    transform: scale(1.1);
    cursor: pointer;
    background-color: #89dddb;
    color: black;
  }
`;

export const Error = styled.p`
color: red;
font-size: 12px;
`
export const Message = styled.p`
color: #3AFD3D;
font-size: 15px;
`